<template>
  <div class="sample-images">
    <div
      v-for="(sampleImage, imageIndex) in sampleImages"
      :key="imageIndex"
      :class="classes(imageIndex)"
    >
      <div class="sample-images__sample-container-inner">
        <img
          :src="sampleImage"
          :alt="`Sample Image ${imageIndex + 1}`"
          class="sample-images__thumbnail"
          @click="$emit('image-clicked', imageIndex)"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LetterJacketSampleImagesNav',
  props: {
    sampleImages: { type: Array, default: function () { return [] }, required: true },
    selectedImageIndex: { type: Number, default: null, required: true }
  },
  methods: {
    classes (imageIndex) {
      return {
        'sample-images__sample-container': true,
        'indicator': this.selectedImageIndex === imageIndex
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sample-images {
  &__thumbnail {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/LetterJacketSampleImages/LetterJacketSampleImagesNav.vue